import { effect, signal } from "@preact/signals";
import { local } from "~/core/local";

const tmpStorage = local("_tmp_st", {
    approved: [] as string[],
    board: [] as string[],
});

const makeMeta = () => {
    const title = signal("Marathon Engage");
    const prefix = signal("");

    // temporary solution
    const approvedBudgets = signal(tmpStorage.get().approved);
    const boardTasks = signal(tmpStorage.get().board);

    effect(() => {
        tmpStorage.set({
            approved: approvedBudgets.value,
            board: boardTasks.value,
        });
    });

    return {
        title,
        prefix,
        approvedBudgets,
        boardTasks,
    };
};

export default makeMeta;
